import { LiveEvent } from '@flocasts/flosports30-types/dist/entity'

export const redirectIsAccountSettings = (redirect: string) => redirect.match(/^\/account.*$/)
export const redirectIsActivate = (redirect: string) => redirect.match(/^\/activate.*$/)
export const nextIsArena = (next: string) => next.match(/arena.*$/)

export const shouldRouteToPlansOrPay = (
  isFreeUser: boolean,
  redirect?: string,
  liveEvent?: LiveEvent,
  next?: string
) => {
  if (redirect && (redirectIsAccountSettings(redirect) || redirectIsActivate(redirect))) {
    return false
  }

  if (next && nextIsArena(next)) {
    return false
  }

  /**
   * If free user is accessing a free live event, skip Plan and Pay routes
   */
  if (isFreeUser && !!redirect) {
    return !(liveEvent && !liveEvent.premium)
  }

  /**
   * Otherwise if a free user, redirect to Plan and Pay routes
   * instead of home page
   */
  if (isFreeUser) {
    return true
  }

  return false
}
